/**
 * base3.xiaojukeji.com/docs/passport/开发指南/PC-passport接入.html
 * base3.xiaojukeji.com/docs/passport/概览/术语.html
 */

import qs from 'qs';
import config from '@/config/index';
import { isPC, getLoginJs } from '@/lib/passport-h5';
import { setLocalStorage, delLocalStorage } from '@/utils/localStorage';
import { setSessionStorage } from '@/utils/sessionStorage';
import { login_common_logs_fun, login_callback_logs_fun } from '@/const/logs';
import { sleep } from '@/utils/tools';

class Passport {
  constructor({
    passportUrl,
    setCookieUrl,
    appId,
    role,
    source,
    countryId,
    lang,
    theme,
  }) {
    this.config = {
      passportUrl,
      setCookieUrl,
      appId,
      role,
      source,
      countryId,
      lang,
      theme,
    };
  }

  getHref(targetUrl, isLogin) {
    let {
      passportUrl,
      appId,
      role,
      source,
      setCookieUrl,
      countryId,
      lang,
      theme,
    } = this.config;

    let search = window.location.search
    let fromLoginQuery = search?'&fromLogin=1':'?fromLogin=1'
    let fromLoginOutQuery = search?'&fromLogin=2':'?fromLogin=2'

    let currentHref = targetUrl
      .replace(fromLoginQuery, '')
      .replace(fromLoginOutQuery, '');
    const formUrl = isLogin ? fromLoginQuery : fromLoginOutQuery;

    let setCookieUrlQuery = qs.stringify({
      redirectUrl: encodeURI(decodeURI(currentHref + formUrl)),
    });

    let passportUrlQuery = qs.stringify({
      appid: appId,
      role,
      source,
      country_id: countryId,
      redirectUrl: encodeURI(decodeURI(setCookieUrl + '?' + setCookieUrlQuery)),
      lang,
      theme,
    });

    return passportUrl + '?' + passportUrlQuery;
  }

  get currentHref() {
    return this.getHref(location.href, true);
  }

  get currentHrefOut() {
    return this.getHref(location.href, false);
  }

  get homeHref() {
    return this.getHref(location.protocol + '//' + location.host);
  }

  async login() {
    // 唤起登录页埋点
    login_common_logs_fun();
    await sleep(50);

    if (isPC()) {
      setLocalStorage('lastPoiAid','');
      delLocalStorage('userInfo');
      location.href = this.currentHref;
    } else {
      getLoginJs().then(login => {
        login.login(
          async response => {
            const { ticket, cell, uid, userType } = response;
            setLocalStorage('lastPoiAid','');
            setLocalStorage('ticket', ticket);
            delLocalStorage('userInfo');
            setLocalStorage('uid', uid);

            if (window.location?.pathname?.includes('/food/feed')) {
              // 通过首页唤起的登录，加标识。目前用于H5首页天降弹窗状态判断
              setSessionStorage('H5LoginReturnUrl', 'feed');
            }

            // 登陆结果确认埋点
            login_callback_logs_fun();

            await sleep(50);
            location.reload();
          },
          error => {
            console.log(error);
          }
        );
      });
    }
  }

  logout(signOutNoBackFeed) {
    let currentHrefOut = this.currentHrefOut;
    if (!signOutNoBackFeed) {
      let location = window.location;
      let n = location.pathname.indexOf('/food/');
      currentHrefOut = `${location.origin}${location.pathname.substring(
        0,
        n
      )}/food/feed`;
    }
    setLocalStorage('lastPoiAid','');
    if (isPC()) {
      location.href = currentHrefOut + '#/logout';
      delLocalStorage('ticket');
      delLocalStorage('uid');
    } else {
      getLoginJs().then(login => {
        login.logout(
          () => {
            delLocalStorage('ticket');
            delLocalStorage('uid');
            if (!signOutNoBackFeed) {
              location.href = currentHrefOut;
            } else {
              location.reload();
            }
          },
          error => {
            console.log(error);
          }
        );
      });
    }
  }

  register() {
    location.href = this.currentHref + '#/register';
  }

  forget() {
    location.href = this.currentHref + '#/forget';
  }
}

export default new Passport(config.passport);
